export type CuotaLike = {
  id: string;
  numero_cuota: number;
  monto_cuota: number;
  monto_pagado: number;
  fecha_vencimiento: string;
  estado: string;
};

function parseYmdLocal(ymd: string): Date {
  const [y, m, d] = ymd.split('-').map((x) => Number(x));
  return new Date(y || 0, (m || 1) - 1, d || 1, 0, 0, 0, 0);
}

export function startOfTodayLocal(): Date {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0, 0);
}

export function addDaysLocal(d: Date, days: number): Date {
  const x = new Date(d.getTime());
  x.setDate(x.getDate() + days);
  return x;
}

/** Cuota vencida operativamente: vencimiento antes de hoy y no pagada por completo. */
export function cuotaEstaVencidaOperativa(c: CuotaLike): boolean {
  if (c.estado === 'pagada') return false;
  const due = parseYmdLocal(c.fecha_vencimiento);
  return due < startOfTodayLocal();
}

export function proximaCuotaPendiente(cuotas: CuotaLike[]): CuotaLike | null {
  const pend = cuotas.filter((c) => c.estado === 'pendiente' || c.estado === 'parcial');
  if (pend.length === 0) return null;
  pend.sort((a, b) => {
    const da = parseYmdLocal(a.fecha_vencimiento).getTime();
    const db = parseYmdLocal(b.fecha_vencimiento).getTime();
    if (da !== db) return da - db;
    return a.numero_cuota - b.numero_cuota;
  });
  return pend[0] ?? null;
}

export function cuotaMasAntiguaAbierta(cuotas: CuotaLike[]): CuotaLike | null {
  return proximaCuotaPendiente(cuotas);
}

export function saldoCuota(c: CuotaLike): number {
  return Math.max(0, Math.round(Number(c.monto_cuota) || 0) - Math.round(Number(c.monto_pagado) || 0));
}

export type ListBadgeTone = 'green' | 'yellow' | 'red';

export function badgeToneListado(
  estadoCredito: string,
  cuotas: CuotaLike[]
): ListBadgeTone {
  const hoy = startOfTodayLocal();
  const limite3 = addDaysLocal(hoy, 3);
  const prox = proximaCuotaPendiente(cuotas);
  const hayVencida = cuotas.some((c) => cuotaEstaVencidaOperativa(c));
  if (estadoCredito === 'vencido' || hayVencida) return 'red';
  if (!prox) return 'green';
  const due = parseYmdLocal(prox.fecha_vencimiento);
  if (due >= hoy && due <= limite3) return 'yellow';
  return 'green';
}

export function labelEstadoCuota(estado: string): string {
  const m: Record<string, string> = {
    pendiente: 'Pendiente',
    parcial: 'Parcial',
    pagada: 'Pagada',
    vencida: 'Vencida',
  };
  return m[estado] ?? estado;
}

export function labelEstadoCredito(estado: string): string {
  const m: Record<string, string> = {
    activo: 'Activo',
    vencido: 'Vencido',
    pagado: 'Pagado',
    cancelado: 'Cancelado',
  };
  return m[estado] ?? estado;
}
